export default "__VITE_ASSET__Bd1flbS8__"